import {
  NEW_OK_CANCEL_DIALOG,
  SET_CONTENT,
  SET_RESOLVE,
  SHOW_DIALOG,
  RESET_STATE
} from "./constants.js";

const regex = /^(okCancelDialog\/)/;

const _NEW_OK_CANCEL_DIALOG = NEW_OK_CANCEL_DIALOG.replace(regex, "");

export default {
  async [_NEW_OK_CANCEL_DIALOG](
    { commit },
    {
      title,
      text,
      okText = "Ok",
      cancelText = "Cancel",
      onOk = () => {},
      onCancel = () => {},
      maxWidth = null,
      icon = null,
      layer = 0
    }
  ) {
    commit(SET_CONTENT, {
      title,
      text,
      okText,
      cancelText,
      onOk,
      onCancel,
      maxWidth,
      icon,
      layer
    });
    const promise = new Promise(resolve => {
      commit(SET_RESOLVE, resolve);
    });
    commit(SHOW_DIALOG, true);
    const result = await promise;
    commit(RESET_STATE);
    return result;
  }
};
